import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { GlobalStoreInterface } from '~/store/types/globalStore.interface';
import createWorkspacesSlice from '~/modules/Workspaces/store';

const useGlobalStore = create<GlobalStoreInterface>()(
    devtools((...args) => ({
        ...createWorkspacesSlice(...args),
    }))
);

export default useGlobalStore;
